import { Link } from "react-router-dom";
import logo from "./../assets/images/logo.png";
function Navbar() {

  const logout = async () => {
    await window.open("https://gestapo.sisc.ro/api/auth/logout", "_self");
  };

  return (
    <div className="navbar">
      <img src={logo} alt="logo" className="logo" />
      <div className="options">
        <Link to="/dashboard">Acasa</Link>
        <Link to="/trupe">Trupe</Link>
        <a
          onClick={logout}
        >
          <span className="material-symbols-outlined btnLogout">logout</span>
        </a>
      </div>
    </div>
  );
}

export default Navbar;
